export const BLOGS_GET_ALL = "BLOGS_GET_ALL";
export const BLOGS_ADD_NEW = "BLOGS_ADD_NEW";
export const BLOGS_UPDATE = "BLOGS_UPDATE";
export const BLOGS_DELETE = "BLOGS_DELETE"; 
export const BLOGS_GET_COMMENTS = "BLOGS_GET_COMMENTS"
export const BLOG_DELETE_COMMENT = "BLOG_DELETE_COMMENT"
export const BLOG_DELETE_COMMENTS = "BLOG_DELETE_COMMENTS"